import React from 'react';
import ReactPaginate from 'react-paginate';
import { PRODUCT_STATES } from '../../../pages/AdminProductsPage/constants';
import BarcodeScanField from './BarcodeScanField';
import ProductPackFields from './ProductPackFields';
import ProductCodeScanField from './ProductCodeScanField';

const getStateFilterLabel = (value) => PRODUCT_STATES.find((s) => s.value === value)?.label || value;

/**
 * Мобільна версія сторінки менеджменту штрихкодів: вертикальні фільтри, картки товарів.
 * Логіка та сама, що в desktop — лише розмітка.
 */
const AdminBarcodeManagementMobileView = ({
  quantityFrom,
  setQuantityFrom,
  searchFilter,
  setSearchFilter,
  barcodeMode,
  setBarcodeMode,
  categoryIdsFilter,
  setCategoryIdsFilter,
  categories,
  stateFilter,
  setStateFilter,
  showStateDropdown,
  setShowStateDropdown,
  stateDropdownRef,
  resetFilters,
  error,
  loading,
  rows,
  pageCount,
  currentPage,
  handlePageClick,
  onBarcodeSaved,
  onPackSaved,
  onBarcodeError,
  onCodeSaved,
  onCodeError,
  setCurrentPage,
  sortBy,
  sortOrder,
  handleSort,
  handleRefresh
}) => {
  return (
    <div className='col-12 p-0 d-lg-none'>
      <h1 className='h5 mb-3 text-center'>Менеджмент штрихкодів</h1>

      <div className='px-2 mb-3'>
        <div className='row'>
          <div className='col-6 pr-1'>
            <div className='mb-2'>
              <p className='mb-1 font-weight-bold'>Кількість від</p>
              <input
                type='number'
                className='form-control'
                min='0'
                placeholder='напр. 1'
                value={quantityFrom}
                onChange={(e) => {
                  setQuantityFrom(e.target.value);
                  setCurrentPage(0);
                }}
              />
            </div>
          </div>
          <div className='col-6 pl-1'>
            <div className='mb-2'>
              <p className='mb-1 font-weight-bold'>Штрихкод</p>
              <select
                className='form-control'
                value={barcodeMode}
                onChange={(e) => {
                  setBarcodeMode(e.target.value);
                  setCurrentPage(0);
                }}
              >
                <option value='all'>Усі товари</option>
                <option value='with'>Зі штрихкодом</option>
                <option value='without'>Без штрихкоду</option>
              </select>
            </div>
          </div>
        </div>

        <div className='mb-2'>
          <p className='mb-1 font-weight-bold'>Категорія</p>
          <select
            className='form-control'
            value={categoryIdsFilter[0] ?? ''}
            onChange={(e) => {
              const v = e.target.value;
              setCurrentPage(0);
              if (v === '') setCategoryIdsFilter([]);
              else setCategoryIdsFilter([Number(v)]);
            }}
          >
            <option value=''>Всі</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className='mb-2'>
          <p className='mb-1 font-weight-bold'>Статус</p>
          <div className='position-relative' ref={stateDropdownRef}>
            <button
              type='button'
              className='form-control text-left d-flex justify-content-between align-items-center'
              onClick={(e) => {
                e.stopPropagation();
                setShowStateDropdown(!showStateDropdown);
              }}
              style={{ backgroundColor: 'white', cursor: 'pointer' }}
            >
              <span className='text-truncate pr-2'>
                {stateFilter.length === 0
                  ? 'Всі'
                  : stateFilter.length === 1
                    ? getStateFilterLabel(stateFilter[0])
                    : `Обрано: ${stateFilter.length}`}
              </span>
              <i className={`bi bi-chevron-${showStateDropdown ? 'up' : 'down'} flex-shrink-0`}></i>
            </button>
            {showStateDropdown && (
              <div
                className='position-absolute w-100 border rounded bg-white shadow'
                style={{ zIndex: 1050, marginTop: '4px', maxHeight: '50vh', overflowY: 'auto' }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className='p-2'>
                  {PRODUCT_STATES.filter((s) => s.value !== '').map((s) => (
                    <div key={s.value} className='form-check d-flex align-items-center py-1'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        id={`state-bc-mob-${s.value}`}
                        checked={stateFilter.includes(s.value)}
                        onChange={(e) => {
                          setCurrentPage(0);
                          if (e.target.checked) {
                            setStateFilter([...stateFilter, s.value]);
                          } else {
                            setStateFilter(stateFilter.filter((v) => v !== s.value));
                          }
                        }}
                        style={{ width: '20px', height: '20px', marginTop: '0', cursor: 'pointer', flexShrink: 0 }}
                      />
                      <label
                        className='form-check-label ml-2'
                        htmlFor={`state-bc-mob-${s.value}`}
                        style={{ fontSize: '0.95rem', cursor: 'pointer', marginBottom: '0', flex: 1 }}
                      >
                        {s.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='mb-2'>
          <p className='mb-1 font-weight-bold'>Пошук по назві товару</p>
          <div className='position-relative d-flex align-items-center'>
            <input
              type='text'
              className='form-control pr-4'
              placeholder='Назва або артикул'
              value={searchFilter}
              onChange={(e) => {
                setSearchFilter(e.target.value);
                setCurrentPage(0);
              }}
            />
            {searchFilter ? (
              <button
                type='button'
                className='btn p-0 border-0 bg-transparent position-absolute'
                style={{ right: '6px', fontSize: '1rem', lineHeight: 1, color: '#6c757d', cursor: 'pointer' }}
                onClick={() => {
                  setSearchFilter('');
                  setCurrentPage(0);
                }}
                title='Очистити пошук'
                aria-label='Очистити пошук'
              >
                <i className='bi bi-x'></i>
              </button>
            ) : null}
          </div>
        </div>

        <div className='row'>
          <div className='col-6 pr-1'>
            <div className='mb-2'>
              <p className='mb-1 font-weight-bold'>Сортувати за</p>
              <select
                className='form-control'
                value={sortBy}
                onChange={(e) => {
                  handleSort(e.target.value);
                }}
              >
                <option value='name'>Назва</option>
                <option value='code'>Артикул</option>
              </select>
            </div>
          </div>
          <div className='col-6 pl-1'>
            <div className='mb-2'>
              <p className='mb-1 font-weight-bold'>Порядок</p>
              <select
                className='form-control'
                value={sortOrder}
                onChange={(e) => {
                  const next = e.target.value === 'desc' ? 'desc' : 'asc';
                  if (next !== sortOrder) handleSort(sortBy);
                }}
              >
                <option value='asc'>Зростання</option>
                <option value='desc'>Спадання</option>
              </select>
            </div>
          </div>
        </div>

        <div className='d-flex justify-content-between pt-2'>
          <button type='button' className='btn btn-sm btn-dark mr-1' onClick={handleRefresh}>
            Оновити
          </button>
          <button type='button' className='btn btn-sm btn-danger' onClick={resetFilters}>
            Очистити фільтр та сортування
          </button>
        </div>
      </div>

      {error ? <div className='alert alert-danger mx-2 py-2 small'>{error}</div> : null}
      {loading ? <div className='text-center text-muted py-3'>Завантаження…</div> : null}

      <div className='px-2'>
        {!loading && rows.length === 0 ? (
          <div className='text-center text-muted py-4'>Нічого не знайдено</div>
        ) : (
          rows.map((p) => (
            <div key={p.id} className='card mb-2 shadow-sm border'>
              <div className='card-body py-2 px-3'>
                <div className='font-weight-bold text-break mb-2' style={{ fontSize: '0.9rem' }}>
                  {p.name || '—'}
                </div>
                <div className='small text-muted mb-1'>Артикул</div>
                <ProductCodeScanField
                  wrapper='div'
                  wrapperClassName='w-100 m-0 p-0 mb-2'
                  inputClassName='form-control form-control-sm barcode-scan-input barcode-scan-input--mobile-card'
                  product={p}
                  onCodeSaved={onCodeSaved}
                  onCodeError={onCodeError}
                />
                <div className='small text-muted mb-1'>Штрихкод</div>
                <BarcodeScanField
                  wrapper='div'
                  wrapperClassName='w-100 m-0 p-0'
                  inputClassName='form-control form-control-sm barcode-scan-input barcode-scan-input--mobile-card'
                  product={p}
                  onBarcodeSaved={onBarcodeSaved}
                  onBarcodeError={onBarcodeError}
                />
                <div className='mt-3'><ProductPackFields product={p} onPackSaved={onPackSaved} onBarcodeError={onBarcodeError} /></div>
              </div>
            </div>
          ))
        )}
      </div>

      {pageCount > 1 && (
        <div className='d-flex justify-content-center mt-3 mb-2 px-2 overflow-auto'>
          <ReactPaginate
            previousLabel={'‹'}
            nextLabel={'›'}
            breakLabel={'…'}
            breakClassName={'break-me'}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={'pagination pagination-sm mb-0'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            forcePage={currentPage}
          />
        </div>
      )}
    </div>
  );
};

export default AdminBarcodeManagementMobileView;
